import {ref} from "vue";
import {DocumentClassSetting} from "@dex/squeeze-client-ts";

/** Setting that enables the LLM extraction for a document class */
export const LLM_EXTRACTION_SETTING = "LLMExtraction";

/**
 * Settings of the document class currently open in the administration.
 *
 * Every view that loads `GET /documentClasses/{id}/settings` publishes the result here via
 * {@link setDocumentClassSettings}
 */
const documentClassSettings = ref<DocumentClassSetting[]>([]);

export function useDocumentClassSettings() {
	/**
	 * Publishes the settings a view just loaded from the API.
	 * @param {DocumentClassSetting[]} settings Settings of the current document class
	 */
	const setDocumentClassSettings = (settings: DocumentClassSetting[]) => {
		documentClassSettings.value = settings ?? [];
	}

	/**
	 * Whether a boolean document class setting is active.
	 * @param {string} settingName Name of the setting, e.g. LLM_EXTRACTION_SETTING
	 */
	const isDocumentClassSettingActive = (settingName: string): boolean => {
		return documentClassSettings.value.some(setting => setting.settingName === settingName && setting.value === 'true');
	}

	return {documentClassSettings, setDocumentClassSettings, isDocumentClassSettingActive};
}
